import { format, isValid, parse, parseISO } from 'date-fns';
import { isNull } from 'tradevan-ui/consts';
import { DATE_FORMAT } from '../../tradevan-ui/config';
import DateEnum from './enum';

/** 日期 string 轉換成 Date */
export const parseDate =
  (dateFormat: string = DATE_FORMAT) =>
  (value = ''): Date =>
    (value || '').length === dateFormat.length
      ? parse(value, dateFormat, new Date())
      : parseISO(value);

/** date 轉為指定日期的 0 刻 */
export const dateRebaseByFormat = (
  value: Date,
  dateFormat = DATE_FORMAT,
): Date => parseDate(dateFormat)(format(value, dateFormat));

export const dateRangeErr = '起始日期不得大於結束日期。';
/** 起迄時間檢查 */
export const dateRangeCheck = (
  startStr: string,
  endStr: string,
  dateFormat = DATE_FORMAT,
): boolean => parseDate(dateFormat)(startStr) <= parseDate(dateFormat)(endStr);

/** dateStr 為空值時為 null，否則轉成 Date */
export const dateStrParse =
  (dateFormat: string = DATE_FORMAT) =>
  (val: string): Date | null =>
    val === '' ? null : parseDate(dateFormat)(val);

/** isoDateStr to dateStr */
export const isoToDateStr = (
  value: string,
  dateFormat = DATE_FORMAT,
): string => {
  const temp = new Date(value || '');
  return isValid(temp) ? format(temp, dateFormat) : '';
};

/** 指定字元於字串取出，ex: yyy/MM/dd 取出 yyy 位置之字串 */
export const getCharStr = (
  /** 文字格式 */
  strFormat: string,
  /** 取值字串 */
  value: string,
  /** 指定字元 */
  charArray: string[],
): string => {
  let idxArray: number[] = [];
  strFormat.split('').forEach((v, i) => {
    if (charArray.some((char) => char === v)) idxArray = [...idxArray, i];
  });

  let str = '';
  value.split('').forEach((v, i) => {
    if (idxArray.some((idx) => idx === i)) str += v;
  });

  return str;
};

export const formatDate =
  (dateFormat = DateEnum.yyyyMMdd) =>
  (val: Date | null) =>
    isNull(val) || !isValid(val) ? '' : format(val, dateFormat);

// #region for react-input-mask
/** 將 dateFormat 轉換成 react-input-mask 所需的 mask */
export const dateMaskTransfer = (dateFormat: DateEnum | string) => {
  switch (dateFormat) {
    case DateEnum['HH:mm:ss']:
      return '99:99:99';
    case DateEnum['HH:mm']:
      return '99:99';
    case DateEnum['yyyy年MM月dd日']:
      return '9999年99月99日';
    case DateEnum.yyyyMMdd:
      return '99999999';
    case DateEnum['yyy/MM/dd']:
      return '999/99/99';
    case DateEnum['民國 yyy/MM/dd']:
      return '民國 999/99/99';
    case DateEnum['yyyy/MM/dd HH:mm:ss']:
      return '9999/99/99 99:99:99';
    case DateEnum['yyyy/MM/dd HH:mm']:
      return '9999/99/99 99:99';
    case DateEnum['yyyy/MM/dd']:
    default:
      return '9999/99/99';
  }
};
// #endregion for react-input-mask
